// Precios de hospedaje. La tabla vive en el API (macarios-api/config/pricing.js)
// y se descarga de GET /pricing, así que aquí NO hay precios escritos: para
// cambiar precios solo se edita ese archivo del API.
import { useEffect, useState } from 'react';
import axios from 'axios';
import { API_BASE_URL } from '../services/api';

// Se descarga una sola vez y se comparte entre todos los componentes.
let pricingPromise = null;

const loadPricing = () => {
  if (!pricingPromise) {
    pricingPromise = axios
      .get(`${API_BASE_URL}/pricing`)
      .then((res) => res.data)
      .catch((error) => {
        pricingPromise = null; // permite reintentar en el siguiente render
        throw error;
      });
  }
  return pricingPromise;
};

// Devuelve { minNights, stayPrices, dogDiscounts, maxDogs } o null
// mientras carga / si falló.
export const usePricing = () => {
  const [pricing, setPricing] = useState(null);
  useEffect(() => {
    let active = true;
    loadPricing()
      .then((data) => active && setPricing(data))
      .catch((error) => console.error('Pricing fetch error:', error));
    return () => {
      active = false;
    };
  }, []);
  return pricing;
};

// Mismo cálculo que baseStayPrice / calculateLodgingPrice en
// macarios-api/config/pricing.js - si cambias uno, cambia el otro.

// Precio de la estancia para 1 perro. null si aún no hay precios o si la
// estancia es menor al mínimo.
export const baseStayPrice = (pricing, nights) => {
  if (!pricing?.stayPrices) return null;
  const { stayPrices, minNights } = pricing;
  if (!Number.isInteger(nights) || nights < minNights) return null;
  const lastNights = Math.max(...Object.keys(stayPrices).map(Number));
  if (nights <= lastNights) return stayPrices[nights];
  // Noches extra: cuestan lo mismo que la última noche de la tabla
  const extraNightPrice = stayPrices[lastNights] - stayPrices[lastNights - 1];
  return stayPrices[lastNights] + (nights - lastNights) * extraNightPrice;
};

// Precio total del hospedaje para todo el grupo. null si aún no se puede calcular.
export const calculateLodgingPrice = (pricing, nights, dogCount) => {
  const base = baseStayPrice(pricing, nights);
  if (base === null) return null;
  const { dogDiscounts } = pricing;
  let total = 0;
  for (let i = 0; i < dogCount; i++) {
    const discount = dogDiscounts[Math.min(i, dogDiscounts.length - 1)];
    total += base * (1 - discount);
  }
  return Math.round(total * 100) / 100;
};
